import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { billingAddressStyles } from "@dana/Overrides/Widgets/OrderDetails/OrderDetailsBillingAddress";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

billingAddressStyles.titleText = mergeToNew(billingAddressStyles.titleText, {
    variant: "h3",
    css: css`
        margin: 0px;
        background: ${themeBackgrounds.lightGray};
        padding: 4px;
        width: 100%;
    `,
});

billingAddressStyles.addressDisplay = mergeToNew(billingAddressStyles.addressDisplay, {
    wrapper: {
        css: css`
            padding: 4px;
        `,
    },
});
